import { Accessibility } from '../../../../utils/Accessibility/Accessibility';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';

export default class LeaderboardPanel extends JunoMembersListPanel {
  mDiv: JQuery<HTMLElement>;
  mConstructorParams: any;
  mActionId = CrowdHub_App.ACTION_ATTEND;
  mRowCount = 0;
  mModuleFactory = new ModuleFactory();
  mModules: any[] = [];
  trappedChildren: any;
  tabNav: TabNav;
  currentTab: any;
  viewSetting: any;

  constructor() {
    super();
  }

  initialize(aConstructorParams) {
    this.mConstructorParams = aConstructorParams;
    this.tabNav = new TabNav();

    if (!CrowdHub_App.CONFIG.HIDE_GROUP_POINTS && !CrowdHub_App.CONFIG.HIDE_POINTS) {
      this.viewSetting = 'usersAndGroups';
    } else if (CrowdHub_App.CONFIG.HIDE_GROUP_POINTS && !CrowdHub_App.CONFIG.HIDE_POINTS) {
      this.viewSetting = 'users';
    } else if (!CrowdHub_App.CONFIG.HIDE_GROUP_POINTS && CrowdHub_App.CONFIG.HIDE_POINTS) {
      this.viewSetting = 'groups';
    }

    super.initialize(aConstructorParams);
    this.mDiv.addClass('leaderboard_panel');
  }

  setup() {
    this.generateHeader();
    if (this.viewSetting == 'usersAndGroups') {
      this.setupTabNav();
    }
    this.setLeaders();
    this.addTime();
    this.setupAds();

    this.mDiv.find('#content_list').addClass('session_max_width_container center_withmargins');
  }

  setupAds() {
    var self = this;

    if (CrowdHub_App.CONFIG.leaderboard) {
      if (CrowdHub_App.CONFIG.leaderboard.Icon.length > 0) {
        self.mDiv
          .find('.ad_container')
          .css('background-image', 'url(' + App.INSTANCE.getImageSrc(CrowdHub_App.CONFIG.leaderboard.Icon) + ')');
        self.mDiv.find('.ad_container').click(function () {
          self.onHide();
          App.INSTANCE.routeToContent(CrowdHub_App.CONFIG.leaderboard);
        });
      }

      if (CrowdHub_App.CONFIG.leaderboard.Image.length > 0) {
        var s = {
          style: 'cover_absolute',
          backgroundImage: App.INSTANCE.getImageSrc(CrowdHub_App.CONFIG.leaderboard.Image),
        };
        var bg = $(HGEN.tree(s));
        self.mDiv.prepend(bg);

        TweenMax.fromTo(bg, 10, { scale: 1.1 }, { delay: 1, scale: 1, ease: Power3.easeOut });
      }
    }
  }

  setupTabNav() {
    let buttons = [
      {
        id: 'userStandings',
        style: 'leaderboard_select_tab brand_color_border',
        interior: CrowdHub_App.LANG.USER_LEADERBOARD_BUTTON,
        role: 'button',
      },
      {
        id: 'teamStandings',
        style: 'leaderboard_select_tab brand_color_border',
        interior: CrowdHub_App.LANG.GROUP_LEADERBOARD_BUTTON,
        role: 'button',
      },
    ];
    this.tabNav.initialize({
      buttons: buttons,
      autoSelect: false,
      selectTab: this.mConstructorParams.viewTeamStandingsOnStart ? 1 : 0,
      onSwitch: (aTab, aDiv, aRefresh) => {
        if (aRefresh) {
          this.onTabClicked(aTab);
        }
      },
      container: this.mDiv.find('.leaderboard_select_container'),
    });
    this.currentTab = this.mConstructorParams.viewTeamStandingsOnStart ? buttons[1].id : buttons[0].id;

    this.mDiv.find('.leaderboard_select_tab.selected').prepend(
      HGEN.tree({
        style: 'leader_icon brand_color_fill',
        interior: HGEN.faicon({ style: FontAwesomeConfigurations.ICON_TROPHY_SOLID }),
      }),
    );
  }

  onTabClicked(tab) {
    if (tab.id == this.currentTab) {
      return;
    }
    this.currentTab = tab.id;
    this.setLeaders();
    super.reset();
    super.loadData();

    this.mDiv.find('.leader_icon').remove();
    this.mDiv.find('.leaderboard_select_tab.selected').prepend(
      HGEN.tree({
        style: 'leader_icon brand_color_fill',
        interior: HGEN.faicon({ style: FontAwesomeConfigurations.ICON_TROPHY_SOLID }),
      }),
    );

    var searchBarPlaceholderText =
      this.currentTab == 'teamStandings'
        ? CrowdHub_App.LANG.GROUP_LEADERBOARD_SEARCH
        : CrowdHub_App.LANG.USER_LEADERBOARD_SEARCH;
    this.mDiv.find('.search_users').attr('placeholder', searchBarPlaceholderText);
  }

  generateHeader() {
    var aText = CrowdHub_App.LANG.LEADERBOARD_RESET_TEXT.replace('*|ICON|*', Resources.svg.ICON_POINTSBOLT.src);

    var self = this;
    var aHeader = {
      style: 'leaderboard_header',
      tabindex: -1,
      children: [
        {
          style: 'hide_container',
          role: 'button',
          interior: HGEN.image({ src: Resources.resources.ICON_ARROW_DOWN_BLACK.src, style: 'contrast' }) + ' Close',
          tabindex: 0,
        },
        { style: 'ad_container cover' },
        {
          style: 'leaderboard_max_width_container center_withmargins',
          children: [
            {
              style: 'title_and_time_container',
              children: [
                {
                  style: 'leaderboard_title content_title',
                  id: 'dialog_title',
                  interior: CrowdHub_App.LANG.LEADERBOARD_HEADER_TITLE,
                  role: 'heading',
                  ariaLevel: 2,
                },
                {
                  style: 'leaderboard_time',
                  children: [{ style: 'time_label', interior: 'Time Left' }, { style: 'time_left' }],
                },
              ],
            },
            {
              if: this.viewSetting == 'usersAndGroups',
              style: 'leaderboard_select_container',
            },
            { style: 'leaderboard_description_container', interior: aText },
            { style: 'leaders_container', children: [] },
            {
              style: 'search_container',
              interior: HGEN.input({ style: 'input search_users', placeholder: 'Search Directory', tabindex: 0 }),
            },
          ],
        },
      ],
    };

    var aTree = $(HGEN.tree(aHeader));
    aTree.appendTo(this.mDiv.find('#before_list_container'));
    this.mDiv.find('.hide_container').focus();

    this.mDiv.find('.search_users').keyup(function () {
      if (self.mTimeout != null) {
        clearTimeout(self.mTimeout);
      }
      self.mTimeout = setTimeout(function () {
        self.onRefresh(true);
      }, 250);
    });

    Environment.addTouchEvents(
      this.mDiv.find('.hide_container'),
      function () {
        self.onHide();
      },
      null,
    );
  }

  setLeaders() {
    var self = this;
    console.log(App.INSTANCE.CurrentUser);
    var apiData;

    switch (this.viewSetting) {
      case 'usersAndGroups':
        if (this.currentTab == 'teamStandings') {
          apiData = { per_page: 3 };
          break;
        }
        apiData = { page_num: 0, per_page: 3, sort_by: 'user_points', load_preferred_tags: true };
        break;
      case 'users':
        apiData = { page_num: 0, per_page: 3, sort_by: 'user_points', load_preferred_tags: true };
        break;
      case 'groups':
        apiData = { per_page: 3 };
        break;
    }

    if (CrowdHub_App.CONFIG.LEADERBOARD_TAG_TYPE != null) {
      var preferredTagObj = App.INSTANCE.CurrentUser.GetFirstPreferredTagOfType(
        CrowdHub_App.CONFIG.LEADERBOARD_TAG_TYPE,
      );
      if (preferredTagObj != null) {
        apiData.preferred_tag = preferredTagObj.tag_id;
      }
    }

    if (
      CrowdHub_App.CONFIG.USER_LISTS_NOT_TAG_ID instanceof Array &&
      CrowdHub_App.CONFIG.USER_LISTS_NOT_TAG_ID.length > 0
    ) {
      apiData.not_tag_id = [...CrowdHub_App.CONFIG.USER_LISTS_NOT_TAG_ID];
    }

    App.INSTANCE.mApi.Request(
      this.getUrl(),
      apiData,
      aData => {
        if (aData.success == 'true') {
          console.log(aData);
          self.mDiv.find('.leaders_container').empty();
          for (let i = 0; i < aData.content.length; i++) {
            let text = '';
            switch (i) {
              case 0:
                text = '1st';
                break;

              case 1:
                text = '2nd';
                break;

              case 2:
                text = '3rd';
                break;
            }
            const struct = {
              style: 'leader_head',
              children: [
                {
                  style: 'avatar_container cover',
                  children: [
                    {
                      style: 'leader_position',
                      interior: text,
                      ariaLabel: `${text} place`,
                      ariaDescribedby: `user-details-${i}`,
                    },
                  ],
                },
                {
                  style: 'details_section',
                  id: `user-details-${i}`,
                  children: [
                    { style: 'user_name', interior: aData.content[i].user_firstname || aData.content[i].content_name },
                    {
                      style: 'user_points_container',
                      children: [
                        {
                          style: 'user_points',
                          interior: aData.content[i].user_points || aData.content[i].group_points,
                        },
                        {
                          style: 'user_points_icon brand_color_color',
                          interior: HGEN.faicon({ style: FontAwesomeConfigurations.ICON_POINTSBOLT_SOLID }),
                        },
                      ],
                    },
                  ],
                },
              ],
            };

            var tree = $(HGEN.tree(struct));
            tree
              .find('.avatar_container')
              .css(
                'background-image',
                'url(' + App.INSTANCE.getImageSrc(aData.content[i].user_icon || aData.content[i].content_icon) + ')',
              );
            tree.appendTo(self.mDiv.find('.leaders_container'));
          }
        } else {
          App.INSTANCE.showTextMessage(aData.message, 2000);
        }
      },
      () => {
        let confirmPopup = new ConfirmPopupPanel();
        confirmPopup.showOkConfirm('', CrowdHub_App.LANG.LEADERBOARD_DATA_ERROR, null);
      },
    );
  }

  onHide() {
    var self = this;
    App.INSTANCE.mMessageController.hide(self, UITransitions.slideUp);
    Accessibility.removeFromFocusStack(this.trappedChildren);
    if (Accessibility.focusedElement) {
      $(Accessibility.focusedElement).trigger('focus');
    }
  }

  addTime() {
    //COUNTDOWN TO RESET THINGY
    if (CrowdHub_App.CONFIG.leaderboard && CrowdHub_App.CONFIG.leaderboard.RawData != null) {
      var countdown = new LabeledCountdown();

      var j = new LeaderboardContent();
      j.initialize(CrowdHub_App.CONFIG.leaderboard.RawData);
      j.Name = CrowdHub_App.LANG.SCOREBOARD_COUNTDOWN_TEXT;

      countdown.initialize({
        content: j,
      });

      this.mDiv.find('.time_left').html(countdown.mDiv);
    } else {
      this.mDiv.find('.time_label').hide();
    }
  }

  getUrl() {
    switch (this.viewSetting) {
      case 'usersAndGroups':
        if (this.currentTab == 'teamStandings') {
          return 'api_groups_get_by_points.php';
        }
        return 'api_user_search.php';
      case 'users':
        return 'api_user_search.php';
      case 'groups':
        return 'api_groups_get_by_points.php';
    }
  }

  onViewTeamData(aData) {
    var self = this;

    let returnedList: any[] = [];
    returnedList = aData['content'];
    var showRank = aData['show_rank'];

    var aPage: any[] = [];

    // pretend groups are users shhh
    for (var p = 0; p < returnedList.length; p++) {
      var bContent = new User();
      var initData = {
        user_points: returnedList[p].group_points,
        user_firstname: returnedList[p].content_name,
        user_lastname: '',
        user_avatar: returnedList[p].content_icon,
        user_id: returnedList[p].content_id,
        user_rank: returnedList[p].content_rank,
      };
      bContent.initialize({ ...initData, canDelete: false });
      aPage.push(bContent);
      self.willShow(bContent);
    }

    self.addContent(aPage, showRank);

    // team rows should not look clickable for now
    if (this.isGroupView()) {
      this.defaultRowCursor();
    }
  }

  onData(aData) {
    switch (this.viewSetting) {
      case 'usersAndGroups':
        if (this.currentTab == 'teamStandings') {
          this.onViewTeamData(aData);
          break;
        }
        super.onData(aData);
        break;
      case 'users':
        super.onData(aData);
        break;
      case 'groups':
        this.onViewTeamData(aData);
        break;
    }
  }

  getVars() {
    var vars = BaseListPanel.prototype.getVars.call(this);
    vars.show_rank = true;

    if (this.mDiv.find('.search_users').val() != '') {
      vars.search_term = this.mDiv.find('.search_users').val();
    }

    if (this.isGroupView()) {
      return vars;
    }

    vars.load_preferred_tags = 'true';
    vars.sort_by = 'user_points';

    if (CrowdHub_App.CONFIG.LEADERBOARD_TAG_TYPE != null) {
      var preferredTagObj = App.INSTANCE.CurrentUser.GetFirstPreferredTagOfType(
        CrowdHub_App.CONFIG.LEADERBOARD_TAG_TYPE,
      );
      if (preferredTagObj != null) {
        vars.preferred_tag = preferredTagObj.tag_id;
      }
    }
    if (
      CrowdHub_App.CONFIG.USER_LISTS_NOT_TAG_ID instanceof Array &&
      CrowdHub_App.CONFIG.USER_LISTS_NOT_TAG_ID.length > 0
    ) {
      vars.not_tag_id = [...CrowdHub_App.CONFIG.USER_LISTS_NOT_TAG_ID];
    }
    vars.user_id = App.INSTANCE.CurrentUser.Id;
    vars.load_leaderboard = true;
    return vars;
  }

  onViewPost(aRowObject) {
    if (App.CORDOVA == true) {
      this.trappedChildren.release();
    }
    removeInputFocus(App.CORDOVA);
    App.INSTANCE.viewUser(aRowObject.mUser);

    App.INSTANCE.reportActivity(
      0,
      'Leaderboard',
      'View User',
      aRowObject.mUser.Firstname + ' ' + aRowObject.mUser.Lastname,
      aRowObject.mUser.Id,
    );
  }

  onResize(aWidth, aHeight) {
    var self = this;
    for (var p = 0; p < this.mModules.length; p++) {
      this.mModules[p].onResize(aWidth, aHeight);
    }

    UIObject.prototype.onResize.call(this, aWidth, aHeight);
  }

  onTransitionIn() {
    var self = this;
    BaseListPanel.prototype.onTransitionIn.call(this);

    App.INSTANCE.reportActivity(0, 'Leaderboard', 'View Leaderboard', 'View Leaderboard', null);

    // team rows should not look clickable for now
    if (this.isGroupView()) {
      this.defaultRowCursor();
      this.mDiv.find('.search_users').attr('placeholder', 'Search Teams');
    }
  }

  onTransitionInComplete() {
    var self = this;

    this.mDiv.find('#contents').click(function (e) {
      e.stopPropagation();
    });

    this.trappedChildren = Accessibility.trapFocus(this.mDiv);

    this.mDiv.click(function (e) {
      self.onHide();
    });

    this.mDiv.find('.hide_container').focus();
  }

  noResults() {
    return CrowdHub_App.LANG.NO_LEADERBOARD_RESULTS;
  }

  onTransitionOut() {
    if (this.mConstructorParams.onCleanup != null) {
      this.mConstructorParams.onCleanup();
    }
    Accessibility.removeFromFocusStack(this.trappedChildren);
  }

  returnedListName() {
    return 'content';
  }

  isGroupView() {
    return (this.viewSetting == 'usersAndGroups' && this.currentTab == 'teamStandings') || this.viewSetting == 'groups';
  }

  defaultRowCursor() {
    if (this.isGroupView()) {
      this.mDiv.find('.livesessionmember_row').css('cursor', 'default');
    }
  }
}
